<template>
  <CoreAppFooterBlock />
</template>
